import { ContactInfoCard, FAQ } from './types';
import { NAP } from './site';

export const HERO = {
  title: 'Get in Touch',
  subtitle:
    "Ready to transform your business with innovative technology solutions? Let's start a conversation about your goals and how we can help achieve them.",
};

/**
 * DECISION FOR A HUMAN (Task 6): the source had two contradictory response
 * time promises on this page -- "within 24 hours" (form description) and
 * "within 2-4 hours during business hours" (Quick Response Promise card).
 * "24 hours" was kept as the single, safer commitment; a human should
 * confirm this against the actual SLA. See REMEDIATION_NOTES.md.
 */
export const RESPONSE_TIME = {
  formDescription: "Fill out the form below and we'll get back to you within 24 hours.",
  promiseHeading: 'Quick Response Promise',
  promiseBody: 'We aim to respond to all inquiries within 24 hours. For urgent matters, please call us directly.',
};

export const CONTACT_INFO: ContactInfoCard[] = [
  {
    iconKey: 'email',
    title: 'Email',
    lines: [NAP.email],
    link: `mailto:${NAP.email}`,
    description: 'Send us an email anytime',
  },
  {
    iconKey: 'phone',
    title: 'Phone',
    lines: [NAP.phone.display],
    link: NAP.phone.href,
    description: 'Call us during business hours',
  },
  {
    iconKey: 'address',
    title: 'Address',
    lines: [NAP.address.full],
    link: null,
    description: 'Visit our headquarters',
  },
  {
    iconKey: 'hours',
    // Business hours previously contained a literal "\n" that never
    // rendered as a line break -- it's a two-item `lines` array now.
    title: 'Business Hours',
    lines: NAP.hours.lines,
    link: null,
    description: `${NAP.hours.timezone} Zone`,
  },
];

export const FAQS: FAQ[] = [
  {
    question: 'How quickly can you start a project?',
    answer: 'Most projects can begin within 1-2 weeks after contract signing, depending on scope and resource availability.',
  },
  {
    question: 'Do you offer ongoing support?',
    answer: 'Yes, we provide comprehensive post-implementation support and maintenance services to ensure continued success.',
  },
  {
    question: 'What industries do you serve?',
    answer:
      'We work with organizations across all industries, with particular expertise in Data Centers, healthcare, financial services, and manufacturing.',
  },
  {
    question: 'Do you provide training?',
    answer:
      'Absolutely! We include comprehensive training we have ServiceNow Certified Instructors that work with the RiseUp program.',
  },
];

export const MAP_SECTION = {
  heading: 'Our Location',
  mapEmbedSrc: 'https://maps.google.com/maps?q=1%20Creative%20Place%20Charleston%20WV%2025311&z=13&output=embed',
  mapTitle: 'BizSolutions Location',
  videoEmbedSrc:
    'https://www.youtube.com/embed/ANGk0haAC7w?autoplay=1&mute=1&loop=1&playlist=ANGk0haAC7w&controls=0&modestbranding=1&rel=0',
  videoTitle: 'BizSolutions Location Video',
};

export const FAQ_SECTION = {
  heading: 'Frequently Asked Questions',
  subtitle: 'Get quick answers to common questions about our services and process.',
};

export const FORM_SECTION = {
  heading: 'Send Us a Message',
};

export const INFO_SECTION = {
  heading: 'Contact Information',
  description: "We're here to help and answer any questions you might have. We look forward to hearing from you.",
  connectHeading: 'Connect With Us',
  youtubeText: 'Subscribe to our YouTube channel to see future demonstrations of our work',
};
